module.exports = __webpack_public_path__ + "static/media/1POLICY17.312e4312.jpg";